module.exports = __webpack_public_path__ + "static/media/postBtn.69050c66.svg";